module.exports = __webpack_public_path__ + "static/img/wx-pms-3.feb831b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx-pms-3.jpg
// module id = +3kD
// module chunks = 1